import React from "react";
import { useToast } from "../ToastContext";
import "../css/toast.css";

export default function Toast() {
  const { toasts, removeToast } = useToast();

  const handleAction = (toast) => {
    if (typeof toast.onAction === "function") {
      toast.onAction();
    }
    removeToast(toast.id);
  };

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast-${toast.type}`}
          role="status"
          aria-live="polite"
        >
          <div className="toast-content">{toast.message}</div>
          {toast.actionLabel ? (
            <button
              className="toast-action"
              onClick={() => handleAction(toast)}
            >
              {toast.actionLabel}
            </button>
          ) : null}
          <button
            className="toast-close"
            onClick={() => removeToast(toast.id)}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
}
